import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconBellLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 18.884a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.215h1.058V9.923c0-1.345.415-2.534 1.245-3.567a5.517 5.517 0 0 1 3.197-1.983V3.75c0-.347.121-.642.364-.885.243-.244.538-.365.885-.365s.642.122.885.365c.244.243.366.538.366.885v.623a5.517 5.517 0 0 1 3.197 1.983c.83 1.033 1.245 2.222 1.245 3.567v7.462h1.058c.212 0 .39.072.534.215a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.215H5.25Zm6.748 2.808a1.74 1.74 0 0 1-1.276-.53 1.742 1.742 0 0 1-.53-1.277h3.616c0 .498-.177.924-.532 1.277-.354.354-.78.53-1.278.53Zm-4.19-4.307h8.384V9.923c0-1.158-.409-2.146-1.228-2.964C14.146 6.14 13.159 5.73 12 5.73s-2.146.41-2.964 1.228c-.819.818-1.228 1.806-1.228 2.964v7.462Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconBellLine;
